export const getDocumentIconClassName = (doc) => {
  switch (doc.fileType) {
  case '.pdf':
    return 'fa-file-pdf';
  case '.xls':
  case '.xlsx':
    return 'fa-file-xls';
  case '.jpg':
  case '.jpeg':
    return 'fa-file-jpg';
  case '.png':
    return 'fa-file-png';
  default:
    return 'fa-file';
  }
};
